function createSpirographSketch(internalPenDist, internalCircleDiameter, externalPenDist, externalCircleDiameter, mainCircDiam = 800) {
  return function (p) {
    let gfx;

    let mainCircleX = 0;
    let mainCircleY = 0;
    let mainCircleDiameter = mainCircDiam;

    let internalSmallCircleX;
    let internalSmallCircleY;
    let internalSmallCircleDiameter = internalCircleDiameter;

    let externalSmallCircleX;
    let externalSmallCircleY;
    let externalSmallCircleDiameter = externalCircleDiameter;

    let internalPenX;
    let internalPenY;

    let trailPosesInternal = [];
    let trailPosesExternal = [];
    let maxTrailLength = 10000;
    p.setup = () => {
      p.createCanvas(1000, 1000);
      p.background(30);
      p.angleMode(p.DEGREES);
      p.frameRate(60);
      gfx = p.createGraphics(1000, 1000);
    };

    p.draw = () => {
      
      gfx.push();
      gfx.background(30);
      gfx.translate(gfx.width / 2, gfx.height / 2);
      //setting color of circles
      gfx.stroke(255);
      //removing fill
      gfx.noFill();
      //drawing large static circle
      gfx.circle(mainCircleX, mainCircleY, mainCircleDiameter);

      var lCradius = mainCircleDiameter / 2;
      var sICradius = internalSmallCircleDiameter / 2;
      var sECradius = externalSmallCircleDiameter / 2;
      var offsetInternal = lCradius - sICradius;
      var offsetExternal = lCradius + sECradius;

      //internal circle
      internalSmallCircleX = offsetInternal * p.cos(p.frameCount);
      internalSmallCircleY = offsetInternal * p.sin(p.frameCount);
      gfx.circle(
        internalSmallCircleX,
        internalSmallCircleY,
        internalSmallCircleDiameter
      );

      //external circle
      externalSmallCircleX = offsetExternal * p.cos(p.frameCount);
      externalSmallCircleY = offsetExternal * p.sin(p.frameCount);
      gfx.circle(
        externalSmallCircleX,
        externalSmallCircleY,
        externalSmallCircleDiameter
      );
      gfx.pop();
      p.image(gfx, 0, 0);

      //animating and drawing point (pen - internal)
      p.push();
      p.translate(p.width / 2, p.height / 2);
      //Speed Constant
      let internalPenRadius = internalPenDist
      let penAngleInternal = p.frameCount;
      internalPenX =
        offsetInternal * p.cos(penAngleInternal) +
        internalPenRadius * p.cos((offsetInternal / sICradius) * p.frameCount);
      internalPenY =
        offsetInternal * p.sin(penAngleInternal) -
        internalPenRadius * p.sin((offsetInternal / sICradius) * p.frameCount);
      p.fill(100);
      p.circle(internalPenX, internalPenY, 50);

      //animating and drawing point (pen - external)
      let externalPenRadius = externalPenDist
      let penAngleExternal = p.frameCount;
      let externalPenX =
        offsetExternal * p.cos(penAngleExternal) -
        externalPenRadius * p.cos((offsetExternal / sECradius) * p.frameCount);
      let externalPenY =
        offsetExternal * p.sin(penAngleExternal) -
        externalPenRadius * p.sin((offsetExternal / sECradius) * p.frameCount);
      p.fill(100);
      p.circle(externalPenX, externalPenY, 50);

      //Adding current pen position to array
      trailPosesInternal.push({ x: internalPenX, y: internalPenY });
      trailPosesExternal.push({ x: externalPenX, y: externalPenY });
      //removing the oldest pen position
      if (trailPosesInternal.length > maxTrailLength)
        trailPosesInternal.shift();
      p.noFill();
      p.stroke("red");
      p.beginShape();
      for (let i = 0; i < trailPosesInternal.length; i++) {
        let posInternal = trailPosesInternal[i];
        p.curveVertex(posInternal.x, posInternal.y);
      }
      p.endShape();
      p.beginShape();
      for (let i = 0; i < trailPosesExternal.length; i++) {
        let posExternal = trailPosesExternal[i];
        p.curveVertex(posExternal.x, posExternal.y);
      }
      p.endShape();
      p.pop();
    };
    p.Update = (newInternalPenDist) => {
      internalPenDist = newInternalPenDist
    }
  };
}

export default createSpirographSketch;
